import * as CheckboxBase from "@radix-ui/react-checkbox";
import { FaCheck } from "react-icons/fa";

export type CheckboxProps = {
  checked: boolean;
  id?: string;
  name?: string;
  onChange?: (checked: boolean) => void;
  onBlur?: () => void;
};

export const Checkbox = (props: CheckboxProps) => {
  const { id, checked, name, onChange, onBlur } = props;
  return (
    <CheckboxBase.Root
      id={id}
      className="grid h-[14px] w-[14px] place-items-center rounded-sm bg-white"
      checked={checked}
      onCheckedChange={onChange}
      onBlur={onBlur}
      name={name}
    >
      <CheckboxBase.Indicator>
        <FaCheck className="text-primary h-2 w-2" />
      </CheckboxBase.Indicator>
    </CheckboxBase.Root>
  );
};
